import qs from 'qs';
import request from '../index';

// 获取设备列表
export const getEquipmentVoList = (data) => request.get(`/api-eye/getEquipmentVoList?${qs.stringify(data)}`);

export const saveEquipmentVo = (data) => request.post('/api-eye/saveEquipmentVo', data);

// 天鸽异常结果图片列表
export const getColumbaVoList = (data) => request.get(`/api-eye/getColumbaVoList?${qs.stringify(data)}`);

// 创建租赁套餐
export const insertLease = (data) => request.post('/api-eye/lease/insertLease', data);

// 更新客户信息
export const updateLeaseInfo = (data) => request.put('/api-eye/lease/updateLease', data);

// 获得所有租赁列表
export const getLeaseList = (params) => request.get('/api-eye/lease/getLeaseList', { params });

// 删除
export const deleteLease = (data) => request.delete('/api-eye/lease/deleteLease', { data });

// 增加一期
export const addOneStage = (data) => request.get(`/api-eye/lease/addOneStage?${qs.stringify(data)}`);

// 增加天数或者次数
export const updateLease = (data) => request.get(`/api-eye/lease/updateLease?${qs.stringify(data)}`);
